/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  DocusignConfigurationStatus
} from '../../model';

import { customInstance } from '../../../mutator';
import type { ErrorType } from '../../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getDocusignGetConsentUriUrl = () => {


  

  return `/api/Docusign/GetConsentUri`
}

export const docusignGetConsentUri = async ( options?: RequestInit): Promise<string> => {
  
  return customInstance<string>(getDocusignGetConsentUriUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getDocusignGetConsentUriQueryKey = () => {
    return [
    `/api/Docusign/GetConsentUri`
    ] as const;
    }

    
export const getDocusignGetConsentUriQueryOptions = <TData = Awaited<ReturnType<typeof docusignGetConsentUri>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof docusignGetConsentUri>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDocusignGetConsentUriQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof docusignGetConsentUri>>> = ({ signal }) => docusignGetConsentUri({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof docusignGetConsentUri>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type DocusignGetConsentUriQueryResult = NonNullable<Awaited<ReturnType<typeof docusignGetConsentUri>>>
export type DocusignGetConsentUriQueryError = ErrorType<unknown>


export function useDocusignGetConsentUri<TData = Awaited<ReturnType<typeof docusignGetConsentUri>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof docusignGetConsentUri>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof docusignGetConsentUri>>,
          TError,
          Awaited<ReturnType<typeof docusignGetConsentUri>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDocusignGetConsentUri<TData = Awaited<ReturnType<typeof docusignGetConsentUri>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof docusignGetConsentUri>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof docusignGetConsentUri>>,
          TError,
          Awaited<ReturnType<typeof docusignGetConsentUri>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDocusignGetConsentUri<TData = Awaited<ReturnType<typeof docusignGetConsentUri>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof docusignGetConsentUri>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useDocusignGetConsentUri<TData = Awaited<ReturnType<typeof docusignGetConsentUri>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof docusignGetConsentUri>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getDocusignGetConsentUriQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getDocusignGetConsentUriSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof docusignGetConsentUri>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof docusignGetConsentUri>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDocusignGetConsentUriQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof docusignGetConsentUri>>> = ({ signal }) => docusignGetConsentUri({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof docusignGetConsentUri>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type DocusignGetConsentUriSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof docusignGetConsentUri>>>
export type DocusignGetConsentUriSuspenseQueryError = ErrorType<unknown>


export function useDocusignGetConsentUriSuspense<TData = Awaited<ReturnType<typeof docusignGetConsentUri>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof docusignGetConsentUri>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDocusignGetConsentUriSuspense<TData = Awaited<ReturnType<typeof docusignGetConsentUri>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof docusignGetConsentUri>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDocusignGetConsentUriSuspense<TData = Awaited<ReturnType<typeof docusignGetConsentUri>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof docusignGetConsentUri>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useDocusignGetConsentUriSuspense<TData = Awaited<ReturnType<typeof docusignGetConsentUri>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof docusignGetConsentUri>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getDocusignGetConsentUriSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getDocusignGetRSAKeyOrGenerateNewUrl = () => {


  

  return `/api/Docusign/GetRSAKeyOrGenerateNew`
}

export const docusignGetRSAKeyOrGenerateNew = async ( options?: RequestInit): Promise<string> => {
  
  return customInstance<string>(getDocusignGetRSAKeyOrGenerateNewUrl(),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getDocusignGetRSAKeyOrGenerateNewMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof docusignGetRSAKeyOrGenerateNew>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof docusignGetRSAKeyOrGenerateNew>>, TError,void, TContext> => {

const mutationKey = ['docusignGetRSAKeyOrGenerateNew'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof docusignGetRSAKeyOrGenerateNew>>, void> = () => {
          

          return  docusignGetRSAKeyOrGenerateNew(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DocusignGetRSAKeyOrGenerateNewMutationResult = NonNullable<Awaited<ReturnType<typeof docusignGetRSAKeyOrGenerateNew>>>
    
    export type DocusignGetRSAKeyOrGenerateNewMutationError = ErrorType<unknown>

    export const useDocusignGetRSAKeyOrGenerateNew = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof docusignGetRSAKeyOrGenerateNew>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof docusignGetRSAKeyOrGenerateNew>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getDocusignGetRSAKeyOrGenerateNewMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getDocusignGetDocusignConfigurationStatusUrl = () => {


  

  return `/api/Docusign/GetDocusignConfigurationStatus`
}

export const docusignGetDocusignConfigurationStatus = async ( options?: RequestInit): Promise<DocusignConfigurationStatus> => {
  
  return customInstance<DocusignConfigurationStatus>(getDocusignGetDocusignConfigurationStatusUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getDocusignGetDocusignConfigurationStatusQueryKey = () => {
    return [
    `/api/Docusign/GetDocusignConfigurationStatus`
    ] as const;
    }

    
export const getDocusignGetDocusignConfigurationStatusQueryOptions = <TData = Awaited<ReturnType<typeof docusignGetDocusignConfigurationStatus>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof docusignGetDocusignConfigurationStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDocusignGetDocusignConfigurationStatusQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof docusignGetDocusignConfigurationStatus>>> = ({ signal }) => docusignGetDocusignConfigurationStatus({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof docusignGetDocusignConfigurationStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type DocusignGetDocusignConfigurationStatusQueryResult = NonNullable<Awaited<ReturnType<typeof docusignGetDocusignConfigurationStatus>>>
export type DocusignGetDocusignConfigurationStatusQueryError = ErrorType<unknown>


export function useDocusignGetDocusignConfigurationStatus<TData = Awaited<ReturnType<typeof docusignGetDocusignConfigurationStatus>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof docusignGetDocusignConfigurationStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof docusignGetDocusignConfigurationStatus>>,
          TError,
          Awaited<ReturnType<typeof docusignGetDocusignConfigurationStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDocusignGetDocusignConfigurationStatus<TData = Awaited<ReturnType<typeof docusignGetDocusignConfigurationStatus>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof docusignGetDocusignConfigurationStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof docusignGetDocusignConfigurationStatus>>,
          TError,
          Awaited<ReturnType<typeof docusignGetDocusignConfigurationStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDocusignGetDocusignConfigurationStatus<TData = Awaited<ReturnType<typeof docusignGetDocusignConfigurationStatus>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof docusignGetDocusignConfigurationStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useDocusignGetDocusignConfigurationStatus<TData = Awaited<ReturnType<typeof docusignGetDocusignConfigurationStatus>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof docusignGetDocusignConfigurationStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getDocusignGetDocusignConfigurationStatusQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getDocusignGetDocusignConfigurationStatusSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof docusignGetDocusignConfigurationStatus>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof docusignGetDocusignConfigurationStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDocusignGetDocusignConfigurationStatusQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof docusignGetDocusignConfigurationStatus>>> = ({ signal }) => docusignGetDocusignConfigurationStatus({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof docusignGetDocusignConfigurationStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type DocusignGetDocusignConfigurationStatusSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof docusignGetDocusignConfigurationStatus>>>
export type DocusignGetDocusignConfigurationStatusSuspenseQueryError = ErrorType<unknown>


export function useDocusignGetDocusignConfigurationStatusSuspense<TData = Awaited<ReturnType<typeof docusignGetDocusignConfigurationStatus>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof docusignGetDocusignConfigurationStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDocusignGetDocusignConfigurationStatusSuspense<TData = Awaited<ReturnType<typeof docusignGetDocusignConfigurationStatus>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof docusignGetDocusignConfigurationStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDocusignGetDocusignConfigurationStatusSuspense<TData = Awaited<ReturnType<typeof docusignGetDocusignConfigurationStatus>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof docusignGetDocusignConfigurationStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useDocusignGetDocusignConfigurationStatusSuspense<TData = Awaited<ReturnType<typeof docusignGetDocusignConfigurationStatus>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof docusignGetDocusignConfigurationStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getDocusignGetDocusignConfigurationStatusSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getDocusignUpdateConsentedIntegrationUrl = () => {


  

  return `/api/Docusign/UpdateConsentedIntegration`
}

export const docusignUpdateConsentedIntegration = async ( options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getDocusignUpdateConsentedIntegrationUrl(),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getDocusignUpdateConsentedIntegrationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof docusignUpdateConsentedIntegration>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof docusignUpdateConsentedIntegration>>, TError,void, TContext> => {

const mutationKey = ['docusignUpdateConsentedIntegration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof docusignUpdateConsentedIntegration>>, void> = () => {
          

          return  docusignUpdateConsentedIntegration(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DocusignUpdateConsentedIntegrationMutationResult = NonNullable<Awaited<ReturnType<typeof docusignUpdateConsentedIntegration>>>
    
    export type DocusignUpdateConsentedIntegrationMutationError = ErrorType<unknown>

    export const useDocusignUpdateConsentedIntegration = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof docusignUpdateConsentedIntegration>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof docusignUpdateConsentedIntegration>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getDocusignUpdateConsentedIntegrationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getDocusignResponseUrl = () => {


  

  return `/api/Docusign/docu-sign-response`
}

export const docusignResponse = async ( options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getDocusignResponseUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getDocusignResponseQueryKey = () => {
    return [
    `/api/Docusign/docu-sign-response`
    ] as const;
    }

    
export const getDocusignResponseQueryOptions = <TData = Awaited<ReturnType<typeof docusignResponse>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof docusignResponse>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDocusignResponseQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof docusignResponse>>> = ({ signal }) => docusignResponse({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof docusignResponse>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type DocusignResponseQueryResult = NonNullable<Awaited<ReturnType<typeof docusignResponse>>>
export type DocusignResponseQueryError = ErrorType<unknown>


export function useDocusignResponse<TData = Awaited<ReturnType<typeof docusignResponse>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof docusignResponse>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof docusignResponse>>,
          TError,
          Awaited<ReturnType<typeof docusignResponse>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDocusignResponse<TData = Awaited<ReturnType<typeof docusignResponse>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof docusignResponse>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof docusignResponse>>,
          TError,
          Awaited<ReturnType<typeof docusignResponse>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDocusignResponse<TData = Awaited<ReturnType<typeof docusignResponse>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof docusignResponse>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useDocusignResponse<TData = Awaited<ReturnType<typeof docusignResponse>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof docusignResponse>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getDocusignResponseQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getDocusignResponseSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof docusignResponse>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof docusignResponse>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDocusignResponseQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof docusignResponse>>> = ({ signal }) => docusignResponse({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof docusignResponse>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type DocusignResponseSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof docusignResponse>>>
export type DocusignResponseSuspenseQueryError = ErrorType<unknown>


export function useDocusignResponseSuspense<TData = Awaited<ReturnType<typeof docusignResponse>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof docusignResponse>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDocusignResponseSuspense<TData = Awaited<ReturnType<typeof docusignResponse>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof docusignResponse>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDocusignResponseSuspense<TData = Awaited<ReturnType<typeof docusignResponse>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof docusignResponse>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useDocusignResponseSuspense<TData = Awaited<ReturnType<typeof docusignResponse>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof docusignResponse>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getDocusignResponseSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getDocusignDocUrl = (id: string,) => {


  

  return `/api/Docusign/doc/${id}`
}

export const docusignDoc = async (id: string, options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getDocusignDocUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getDocusignDocQueryKey = (id?: string,) => {
    return [
    `/api/Docusign/doc/${id}`
    ] as const;
    }

    
export const getDocusignDocQueryOptions = <TData = Awaited<ReturnType<typeof docusignDoc>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof docusignDoc>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDocusignDocQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof docusignDoc>>> = ({ signal }) => docusignDoc(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof docusignDoc>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type DocusignDocQueryResult = NonNullable<Awaited<ReturnType<typeof docusignDoc>>>
export type DocusignDocQueryError = ErrorType<unknown>


export function useDocusignDoc<TData = Awaited<ReturnType<typeof docusignDoc>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof docusignDoc>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof docusignDoc>>,
          TError,
          Awaited<ReturnType<typeof docusignDoc>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDocusignDoc<TData = Awaited<ReturnType<typeof docusignDoc>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof docusignDoc>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof docusignDoc>>,
          TError,
          Awaited<ReturnType<typeof docusignDoc>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDocusignDoc<TData = Awaited<ReturnType<typeof docusignDoc>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof docusignDoc>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useDocusignDoc<TData = Awaited<ReturnType<typeof docusignDoc>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof docusignDoc>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getDocusignDocQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getDocusignDocSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof docusignDoc>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof docusignDoc>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDocusignDocQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof docusignDoc>>> = ({ signal }) => docusignDoc(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof docusignDoc>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type DocusignDocSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof docusignDoc>>>
export type DocusignDocSuspenseQueryError = ErrorType<unknown>


export function useDocusignDocSuspense<TData = Awaited<ReturnType<typeof docusignDoc>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof docusignDoc>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDocusignDocSuspense<TData = Awaited<ReturnType<typeof docusignDoc>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof docusignDoc>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDocusignDocSuspense<TData = Awaited<ReturnType<typeof docusignDoc>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof docusignDoc>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useDocusignDocSuspense<TData = Awaited<ReturnType<typeof docusignDoc>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof docusignDoc>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getDocusignDocSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



